import * as React from "react"

import { cn } from "@/lib/utils"

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    // Filter out non-standard attributes that might be added by browser extensions
    const filteredProps = Object.fromEntries(
      Object.entries(props).filter(([key]) => 
        !key.startsWith('fdprocessedid') && 
        !key.startsWith('data-lastpass') &&
        !key.startsWith('data-1p')
      )
    );
    
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        {...filteredProps}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }